import { Component } from 'react';

import classNames from 'classnames';

import styles from './ActionButton.module.css';
import { ArrowRightSVG } from '../../../svgComponents/arrowRightSVG';

export class ActionButton extends Component {
    renderMainContent() {
        const { label, caption, error } = this.props;

        return (
            <div className={styles.content}>
                <div className={styles.label}>{label}</div>
                {caption ? (
                    <div className={styles.caption}>{caption}</div>
                ) : null}
                {error ? <div className={styles.error}>{error}</div> : null}
            </div>
        );
    }

    renderActionIcon() {
        const ActionIcon = this.props.actionIcon;
        if (!ActionIcon) return null;

        return (
            <div className={styles.iconWrapper}>
                <ActionIcon className={styles.icon} />
            </div>
        );
    }
    renderInfoIcon() {
        const { showIcon, infoIcon } = this.props;

        if (showIcon) {
            if (infoIcon) {
                return <div className={styles.infoIcon}>{infoIcon}</div>;
            } else {
                return <ArrowRightSVG className={styles.arrow} />;
            }
        }

        return null;
    }

    render() {
        const { disabled, onClick, className } = this.props;

        const actionIcon = this.renderActionIcon();
        const mainContent = this.renderMainContent();
        const infoIcon = this.renderInfoIcon();

        const actionButtonClassName = classNames(
            className,
            disabled ? styles.ActionButtonDisabled : styles.ActionButtonEnabled
        );

        return (
            <button
                onClick={onClick}
                className={actionButtonClassName}
                disabled={disabled}
                data-testid={this.props['data-testid']}
            >
                {actionIcon}
                {mainContent}
                {infoIcon}
            </button>
        );
    }
}
